import apiClient from "./apiClient";
import { ResourceType, Subcontractor, SubcontractorRequest } from "../types/subcontractTypes";

/**
 * Obtiene el listado del mantenedor de subcontratos.
 * Incluye especialidades, proyectos y la bandera hasHistory ya resuelta por el backend.
 */
export const getSubcontractors = async (): Promise<Subcontractor[]> => {
    const response = await apiClient.get('/Subcontractors');
    return response.data;
};

/** Obtiene una empresa por su identificador. */
export const getSubcontractorById = async (id: number): Promise<Subcontractor> => {
    const response = await apiClient.get(`/Subcontractors/${id}`);
    return response.data;
};

/** Crea una empresa subcontratista. */
export const createSubcontractor = async (request: SubcontractorRequest): Promise<Subcontractor> => {
    const response = await apiClient.post('/Subcontractors', request);
    return response.data;
};

/** Actualiza una empresa existente, incluidas especialidades y proyectos. */
export const updateSubcontractor = async (id: number, request: SubcontractorRequest): Promise<Subcontractor> => {
    const response = await apiClient.put(`/Subcontractors/${id}`, request);
    return response.data;
};

/** Cambia el estado operativo Activo/Inactivo. */
export const updateOperationalStatus = async (id: number, operationalStatus: boolean): Promise<void> => {
    await apiClient.patch(`/Subcontractors/${id}/operational-status`, { operationalStatus });
};

/**
 * Elimina lógicamente una empresa.
 * El backend rechaza la operación si la empresa tiene historial de HH/HM.
 */
export const deleteSubcontractor = async (id: number): Promise<void> => {
    await apiClient.delete(`/Subcontractors/${id}`);
};

/**
 * Empresas seleccionables en el editor de reportes diarios.
 * Filtra por proyecto del reporte, por la sección (especialidad) de la actividad y por el
 * área desde la que se abrió el modal.
 */
export const getAvailableSubcontractors = async (
    projectId: number,
    section: string,
    resourceType: ResourceType
): Promise<Subcontractor[]> => {
    const response = await apiClient.get('/Subcontractors/available', {
        params: { projectId, section, resourceType }
    });
    return response.data;
};
